"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  vertical-align: middle;\n  justify-content: ", ";\n\n  > * {\n    margin: ", " !important;\n    display: inline-block;\n    vertical-align: top;\n\n    &:first-of-type {\n      margin-left: 0 !important;\n    }\n\n    &:last-of-type {\n      margin-right: 0 !important;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// TODO: This might have to move to core-ui.
var ElementAlignment = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.rightAligned ? 'flex-end' : 'flex-start';
}, function (props) {
  return props.alignment;
});

var ElementAlignmentComponent = function ElementAlignmentComponent(_ref) {
  var children = _ref.children,
      rightAligned = _ref.rightAligned,
      centerAligned = _ref.centerAligned,
      spacing = _ref.spacing;
  var alignment = rightAligned ? "0 ".concat(spacing, " 0 0") : centerAligned ? "0 ".concat(spacing) : "0 0 0 ".concat(spacing);
  return /*#__PURE__*/_react["default"].createElement(ElementAlignment, {
    alignment: alignment,
    spacing: spacing
  }, children);
};

ElementAlignmentComponent.propTypes = {
  children: _propTypes["default"].any,
  rightAligned: _propTypes["default"].bool,
  centerAligned: _propTypes["default"].bool,
  spacing: _propTypes["default"].string
};
ElementAlignmentComponent.defaultProps = {
  rightAligned: false,
  centerAligned: false,
  spacing: '8px'
};
var _default = ElementAlignmentComponent;
exports["default"] = _default;